/**
 * The URL as Google Analytics may see it: the same page with every query
 * parameter that can carry an address or a position removed (behaviour-logging
 * TR §11.3).
 *
 * The console's URL is `/app?lat=…&lng=…&loc=<the address>` (addressSearch.js),
 * and GA records the full URL of every page view by default — so without this
 * a consenting visitor's searched address went to Google. `utm_*` and every
 * other parameter survive, so campaign attribution still works.
 *
 * Used for gtag's `page_location` and `page_referrer`, and for every page view.
 * Add a parameter here before shipping anything that puts personal or locating
 * data in a URL.
 */
export const PII_PARAMS = ["lat", "lng", "loc", "address", "q"];

export const scrubUrl = (href) => {
  const url = new URL(href, window.location.origin);
  PII_PARAMS.forEach((p) => url.searchParams.delete(p));
  return url.toString(); // utm_* and other non-PII params survive
};
